import {memo} from 'react'
import ResponsiveDialog from '~/components/common/ResponsiveDialog'
import DesignImage from '~/components/product-details/DesignImage'
import {ProductWithIds} from '~/client/spreadshop/missing-types'
import {useTranslations} from 'use-intl'

type DesignDialogProps = {
    onClose: () => void
    product: ProductWithIds
    open: boolean
}

const DesignDialog = memo(({onClose, product, open}: DesignDialogProps) => {
    const t = useTranslations('productDetails.designDialog')

    return (
        <ResponsiveDialog
            open={open}
            onOpenChange={onClose}
            title={t('title')}
            description={product.name}
            ssr
        >
            <div className="pb-8 px-4 overflow-y-auto md:p-0">
                <div className="empty:hidden mb-4 rounded-lg overflow-hidden shadow-md shadow-gray-600 bg-white">
                    <DesignImage
                        className="mx-auto max-h-60 p-4 pointer-events-none select-none"
                        product={product}
                    />
                </div>
                <div className="space-y-2">
                    <h2 className="font-bold">{product.name}</h2>
                    <div>
                        <h3 className="mb-1 font-bold">{t('descriptionLabel')}</h3>
                        <p className="text-sm">{product.description}</p>
                    </div>
                    {product.tags && (
                        <div>
                            <h3 className="mb-1 font-bold">{t('tagsLabel')}</h3>
                            <ul className="text-xs">
                                {product.tags.map((tag, index) => (
                                    <li className="inline" key={tag}>
                                        {tag}
                                        {index !== (product.tags?.length ?? 1) - 1 ? ', ' : ''}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </ResponsiveDialog>
    )
})

export default DesignDialog
